import { defineMessages } from 'react-intl';

export default defineMessages({
  caption: 'Loan to Value (LTV) Ratio',
  description:
    'The Maximum Loan-to-Value ratio represents the maximum borrowing power of a specific collateral. For example, if a collateral has a LTV of 75%, the user can borrow up to 0.75 worth of ETH in the principal currency for every 1 ETH worth of collateral.',
});
